// import axios from './axios'
import sign from './sign'
import RequestMethods from './request.methods'
import {
  GlAxios
} from 'glsx-vue-common'
const request = (params = {}, url, method = RequestMethods.POST, noSignAttr = []) => {
  params.method = url.trimStart().trimEnd()
    // this.$get_session_common_config().axios.sys.appKey
  params.appKey = window.$config.axios.appKey
    // params.timestamp = new Date().getTime()
  params.v = '1.0.0'
  params.format = 'json'
  params.locale = 'zh_CN'
  let data = sign(params, noSignAttr)
  return GlAxios.post('router', data)
}

export default request